import { UncontrolledTooltip } from "reactstrap"

const ButtonTooltip = ({
  type = "view", // "add" | "edit" | "view" | "delete" | "cancel" | "duplicate" | "refresh" | "download" | "pdf" | "receipt" | "accept" | "decline"
  btnId = "1",
  btnName,
  color: colorProp,
  loading = false,
  is_label = false,
  size = "sm",
  ...props
}) => {
  const btnColors = {
    add: "success",
    edit: "info",
    view: "primary",
    delete: "danger",
    cancel: "secondary",
    duplicate: "warning",
    refresh: "secondary",
    download: "secondary",
    pdf: "dark",
    receipt: "success",
    accept: "success",
    decline: "danger",
  }

  const icons = {
    add: "mdi mdi-plus",
    edit: "mdi mdi-pencil-outline",
    view: "mdi mdi-eye-outline",
    delete: "mdi mdi-delete-outline",
    cancel: "bx bx-x-circle",
    duplicate: loading ? "mdi mdi-loading mdi-spin" : "mdi mdi-content-copy",
    refresh: `mdi mdi-refresh ${loading ? "mdi-spin" : ""}`,
    download: loading ? "mdi mdi-progress-download" : "mdi mdi-download",
    pdf: loading ? "mdi mdi-progress-download" : "mdi mdi-file-pdf-box",
    receipt: "bx bx-receipt",
    accept: loading ? "mdi mdi-loading mdi-spin" : "mdi mdi-check-circle-outline",
    decline: loading ? "mdi mdi-loading mdi-spin" : "mdi mdi-close-circle-outline",
  }

  const labels = {
    add: "Add",
    edit: "Edit",
    view: "View",
    delete: "Delete",
    cancel: "Cancel",
    duplicate: loading ? "Duplicating..." : "Duplicate",
    refresh: "Refresh",
    download: loading ? "Downloading..." : "Download",
    pdf: loading ? "Downloading..." : "Download PDF",
    receipt: "Create Money Receipt",
    accept: loading ? "Accepting..." : "Accept",
    decline: loading ? "Declining..." : "Decline",
  }

  const color = colorProp || btnColors[type] || "secondary"
  const icon = icons[type] || "mdi mdi-help-circle-outline"
  const label = btnName || labels[type] || "Action"

  // handle 'btnId' slugification to ensure valid HTML id (no spaces, special chars)
  const slugifiedBtnId = btnId.toString().toLowerCase().replace(/\s+/g, "-")
  return (
    <button
      type="button"
      className={`btn${size ? ` btn-${size}` : ""} btn-soft-${color}`}
      id={`tooltip-${slugifiedBtnId}`}
      disabled={loading}
      {...props}
    >
      <i className={icon} />
      {is_label ? (
        label
      ) : (
        <UncontrolledTooltip placement="top" target={`tooltip-${slugifiedBtnId}`}>
          {label}
        </UncontrolledTooltip>
      )}
    </button>
  )
}

export default ButtonTooltip
